import { CancelTokenSource } from 'axios';
import { getAccessToken } from '../helpers';
import { CreateExceptionDTO, ExceptionView, IEntityAggrByDate, IException, UpdateExceptionDTO } from '../types';
import { ApiRepository } from './main repository/api.repository';
import { DEFAULT_HEADER } from './main repository/api.type';
import { TimelineDTO } from '../types/timeline.type';

export namespace ExceptionService {
  const BASE_API = `${window.globalConfiguration.api.base}/v1/exceptions`;

  export const deleteOne = async (exceptionId: number): Promise<void> => {
    return ApiRepository.Core().delete(`${BASE_API}/${exceptionId}`);
  };

  export const createOne = async (createExceptionDTO: CreateExceptionDTO): Promise<IException> => {
    return ApiRepository.Core().post<CreateExceptionDTO, IException>(BASE_API, createExceptionDTO);
  };

  export const count = async (aggrByDate: boolean): Promise<number | Array<IEntityAggrByDate>> => {
    return ApiRepository.Core().get(`${BASE_API}/count`, { aggrByDate });
  };

  export const find = async (exceptionIds?: Array<number>, withDeleted = false): Promise<Array<ExceptionView>> => {
    return ApiRepository.Core().get<Array<ExceptionView>>(BASE_API, {
      ...(exceptionIds && { ids: exceptionIds.join(',') }),
      withDeleted,
    });
  };

  export const findOne = async (cancelTokenSource: CancelTokenSource, exceptionId: number): Promise<ExceptionView> => {
    return ApiRepository.Core().get<ExceptionView>(`${BASE_API}/${exceptionId}`, undefined, {
      cancelToken: cancelTokenSource.token,
    });
  };

  export const updateExeption = async (
    cancelTokenSource: CancelTokenSource,
    exceptionId: number,
    updateExceptionDTO: UpdateExceptionDTO
  ): Promise<IException> => {
    return ApiRepository.Core().put(`${BASE_API}/${exceptionId}`, updateExceptionDTO, undefined, {
      headers: {
        ...DEFAULT_HEADER,
        Authorization: getAccessToken() || '',
      },
      cancelToken: cancelTokenSource.token,
    });
  };

  export const getTimeline = async ({
    exceptionId,
    cancelTokenSource,
  }: {
    exceptionId: number;
    cancelTokenSource: CancelTokenSource;
  }): Promise<TimelineDTO> => {
    return ApiRepository.Core().get(`${BASE_API}/${exceptionId}/timeline`, undefined, {
      cancelToken: cancelTokenSource.token,
    });
  };
}
